import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge знает только стандартную шкалу Tailwind. Наши значения из `@theme`
 * (styles/app.css) нужно назвать явно, иначе `text-2xs` считается цветом и вытесняет
 * `text-foreground`, а `shadow-popover` не заменяет `shadow-modal`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['2xs'],
      shadow: ['popover', 'modal', 'focus', 'float', 'tip'],
    },
  },
});

/** Склейка классов: условные части через clsx, конфликты Tailwind — побеждает последний. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
